import gql from 'graphql-tag';

const GET_COUNT_OF_TOTAL_CURSORS = gql`
  query totalCursorsCount($modelName: String, $query: String, $currentTab: Int) {
    totalCursorsCount(modelName: $modelName, query: $query, additionalQuery: $currentTab)
  }
`;

export default GET_COUNT_OF_TOTAL_CURSORS;
